// extracted by mini-css-extract-plugin
module.exports = {"search-container":"style_search-container__1d_oM"};